import { encrypt, sign, getConfig } from "./utils.js";

export default class ssourl {
  endpoint = '';
  vendorId = '';
  platformId = '';
  projectId = '';
  appId = '';
  appSecret = '';
  replyToken = '';
  shortApiId = '';

  constructor() {
    if (getConfig("VUE_APP_ENV") == "dev") console.log('=== ssourl init ===');
  }

  setEnv() {
    if (getConfig("VUE_APP_ENV") == "dev") {
      console.log("vendorId: " + this.vendorId);
      console.log("platformId: " + this.platformId);
      console.log("appId: " + this.appId);
      console.log("appSecret: " + this.appSecret);
      console.log("shortApiId: " + this.shortApiId);
    }
  }

  async genurl(nextUrl = '', user = {
    userId: '',
    userToken: '',
    userName: '',
    userPhone: '',
    userEmail: ''
  }) {
    try
    {
      const customData = {
        "project_id": this.projectId,
        "identity_pool_id": "",
        "identity_id": user.userId,
        "invite_code": "",
        "user_token": user.userToken,
        "user_name": user.userName,
        "user_phone": user.userPhone,
        "user_email": user.userEmail
      };

      const payloadStr = JSON.stringify(customData);
      const encryptedData = encrypt(payloadStr, this.appSecret);
      const timestamp = new Date().getTime();
      const rawData = timestamp + this.vendorId + this.platformId + this.appId + user.userId + user.userToken + this.replyToken + this.shortApiId;
      const computedSign = sign(rawData, this.appSecret);

      const query = {
        "x-3rd-timestamp": timestamp,
        "x-3rd-vendor-id": this.vendorId,
        "x-3rd-platform-id": this.platformId,
        "x-3rd-app-id": this.appId,
        "x-3rd-user-id": user.userId,
        "x-3rd-custom-data": encryptedData,
        "x-3rd-token": this.replyToken,
        "x-3rd-frame-url": "",
        "x-3rd-signature": computedSign,
        "x-3rd-local": true,
        "x-3rd-next-url": nextUrl
      };

      // Add openExternalBrowser query string for app webview detect need open device browser.
      query['openExternalBrowser'] = 1;
      
      const queryString = new URLSearchParams(query).toString();

      const finalUrl = `${this.endpoint}?${queryString}`;

      if (getConfig("VUE_APP_ENV") == "dev") {
        console.log("payloadStr: " + payloadStr);
        console.log("encryptedData: " + encryptedData);
        console.log("timestamp: " + timestamp);
        console.log("rawData: " + rawData);
        console.log("computedSign: " + computedSign);
        console.log("queryString: " + queryString);
        console.log("finalUrl: " + finalUrl);
      }
      
      return finalUrl;
    }
    catch(error)
    {
      console.error("Error during request:", error);
    }
  }
}